// Valid Emails Only
const REGEX_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const passwordValidator = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/;

// Input Not Empty
export const exists = (value?: string) => {
  let trimmedValue = value?.trim();
  return trimmedValue !== "";
};

export const isEmail = (value: string) => {
  return REGEX_EMAIL.test(value);
};

export const isValidPassword = (value: string) => {
  return passwordValidator.test(value);
};

export const isValidAuthCode = (value: string) => {
  return value.length === 6;
};

/**
 * Get the maximum date of birth for someone who must be at least 18 years old
 * @returns Date string in YYYY-MM-DD format representing 18 years ago from today
 */
export const getMaxDateOfBirth = (): string => {
  const today = new Date();
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  );
  return maxDate.toISOString().split("T")[0];
};

/**
 * Get today's date in YYYY-MM-DD format
 * @returns Date string representing today's date
 */
export const getTodaysDate = (): string => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};
